import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import { useSiteContent } from '../../contexts/SiteContentContext';

const AgencyFooter = () => {
  const navigate = useNavigate();
  const { settings } = useSiteContent();

  const brandName = settings.brand_name || 'mispedidos app';
  const contactEmail = settings.contact_email || 'mispedidosapp@gmail.com';
  const whatsappNumber = settings.whatsapp_number || '3425149602';
  const mainDomain = settings.main_domain || 'mispedidosapp.com.ar';

  return (
    <footer className="py-8 px-4 bg-[#1C1C1C] border-t border-[#333333]">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-[#E9FF60] font-bold mb-3">{brandName}</h3>
            <p className="text-gray-400 text-sm">
              Tu plataforma, tus reglas. Sin comisiones, sin intermediarios.
            </p>
            <p className="text-gray-500 text-xs mt-2">{mainDomain}</p>
            {/* Instagram */}
            <div className="mt-4">
              <a
                href="https://www.instagram.com/mispedidos.app/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-gray-400 hover:text-[#E9FF60] transition-colors"
                data-testid="instagram-link"
              >
                <Instagram className="w-5 h-5" />
                <span className="text-sm">Seguinos en Instagram</span>
              </a>
            </div>
          </div>
          <div>
            <h3 className="text-white font-bold mb-3">Contacto</h3>
            <p className="text-gray-400 text-sm mb-2">
              Email: <a href={`mailto:${contactEmail}`} className="hover:text-[#E9FF60]">{contactEmail}</a>
            </p>
            <p className="text-gray-400 text-sm">
              WhatsApp: <a href={`https://wa.me/${whatsappNumber}`} className="hover:text-[#E9FF60]" target="_blank" rel="noopener noreferrer">+54 {whatsappNumber.slice(0,3)} {whatsappNumber.slice(3,6)} {whatsappNumber.slice(6)}</a>
            </p>
          </div>
          <div>
            <h3 className="text-white font-bold mb-3">Links</h3>
            <ul className="text-gray-400 text-sm space-y-2">
              <li><a href="/soluciones" className="hover:text-[#E9FF60]">Soluciones</a></li>
              <li><a href="/planes" className="hover:text-[#E9FF60]">Planes y Precios</a></li>
              <li><a href="/demo" className="hover:text-[#E9FF60]">Solicitá una Demo</a></li>
            </ul>
          </div>
        </div>
        
        <div className="text-center text-gray-400 border-t border-[#333333] pt-6">
          <p className="text-sm">&copy; 2026 {brandName} - Tu plataforma, tus reglas</p>
          <button
            onClick={() => navigate('/superadmin')}
            className="text-gray-600 hover:text-[#E9FF60] text-xs mt-2 opacity-10 hover:opacity-100 transition-opacity"
            data-testid="secret-superadmin-link"
          >
            v1.0
          </button>
        </div>
      </div>
    </footer>
  );
};

export default AgencyFooter;
